package com.nonopn.skywatcher.app.utils

import com.mmk.kmpnotifier.notification.NotifierManager
import com.mmk.kmpnotifier.notification.PayloadData
import korlibs.io.util.UUID
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.async
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.filterNotNull
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException
import kotlin.coroutines.suspendCoroutine

object FirebaseWrapper {
    private val newToken = MutableStateFlow<String?>(null)
    val onToken = newToken.asStateFlow().filterNotNull()

    private val pushNotifications = MutableStateFlow<PushNotification?>(null)
    val onPushNotification = pushNotifications.asStateFlow().filterNotNull()

    private val notificationClicked = MutableStateFlow<PayloadData?>(null)
    val onNotificationClicked = notificationClicked.asStateFlow().filterNotNull()

    var lastNotificationClicked: PayloadData? = null
        internal set

    fun onActivityCreated(data: PayloadData?) {
        lastNotificationClicked = data
    }

    init {
        NotifierManager.setListener(
            object : NotifierManager.Listener {
                override fun onNewToken(token: String) {
                    println("FirebaseWrapper onNewToken")
                    newToken.tryEmit(token)
                }

                override fun onPushNotificationWithPayloadData(
                    title: String?,
                    body: String?,
                    data: PayloadData
                ) {
                    println("FirebaseWrapper onPushNotificationWithPayloadData")
                    pushNotifications.tryEmit(
                        PushNotification(
                            title = title,
                            body = body,
                            data = data,
                            uuid = UUID.randomUUID().toString()
                        )
                    )
                }

                override fun onNotificationClicked(data: PayloadData) {
                    println("FirebaseWrapper onNotificationClicked $data")
                    lastNotificationClicked = data
                    notificationClicked.tryEmit(data)
                }
            })
        println("FirebaseWrapper initialized")
    }

    suspend fun getToken(scope: CoroutineScope): String {
        return suspendCoroutine { continuation ->
            scope.async {
                try {
                    NotifierManager.getPushNotifier().getToken()?.let { token ->
                        continuation.resume(token)
                    }
                } catch (err: Throwable) {
                    continuation.resumeWithException(err)
                }
            }
        }
    }

    data class PushNotification(
        val title: String?,
        val body: String?,
        val data: PayloadData?,
        val uuid: String
    )
}